<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qCHlln/tc-custom/9781847673749.jpg?1734550473900" alt="This image is the cover for the book Lanark, Canons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lanark, Canons
      </h1>
      <p class="bookDescription body article font2">
        <b>The cult classic novel of dreamlike fantasy and psychological realism by the author of <i>Poor Things</i>: A work of “vivid imagination, yielding copious riches.”—<i>The Times Literary Supplement</i></b><br/>  <br/> From its first publication in 1981, Alasdair Gray’s <i>Lanark</i> was hailed as a masterpiece, inspiring Anthony Burgess to proclaim Gray the most important Scottish novelist since Walter Scott. With its echoes of Dante, Blake, Joyce, Kafka, and Lewis Carroll, <i>Lanark</i> has been published around the world to unanimous acclaim.<br/>  <br/> A man wakes up on a train with no memory and seashells in his pockets. He finds himself arriving in a peculiar place called Unthank—where the sun only comes up part-way and the inhabitants are prone to disappearing. He names himself Lanark and soon encounters a gallery of characters who suffer from joblessness, alienation, and strange maladies. The novel’s time-shifting narrative then draws readers into Lanark’s former life in Glasgow as it explores its twin themes of humankind’s inability to love and our compulsion to go on trying.<br/>  <br/> This edition of <i>Lanark</i> features an introduction by the award-winning novelist Janice Galloway, as well as “Gray’s Tailpiece,” a fascinating addendum to the novel.<br/>  <br/> “It was time Scotland produced a shattering work of fiction in the modern idiom. This is it.” —Anthony Burgess, author of <i>A Clockwork Orange</i><br/>  <br/> “A quite extraordinary achievement, the most remarkable thing in Scottish fiction for a very long time.” —<i>Scotsman</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alasdair Gray, William Boyd
      </h2>
      
      <p class="authorDescription body article">Born in 1934,&#160;<B>Alasdair Gray</B>&#160;graduated in design and mural painting from the Glasgow School of Art. Since 1981, when&#160;<I>Lanark </I>was published by Canongate, he authored, designed and illustrated seven novels, several books of short stories, a collection of his stage, radio and TV plays and a book of his visual art,&#160;<I>A Life in Pictures.&#160;</I>In November 2019, he received a Lifetime Achievement award from the Saltire Society.<I>&#160;</I>He died in December 2019, aged eighty-five.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?538e7135